<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
            <v-col cols="12" md="12" class="login-part d-flex align-center justify-center flex-column">
              <div class="login-wrapper pt-16 pt-sm-0">
                    <v-form>
                      <v-container>
                        <v-row class="flex-column">
                          <v-col>
                          <div class="d-flex justify-center" justify="center">
                            <v-img src="@/assets/accountxc-logo.png" contain max-width="250" min-width="100"></v-img>
                          </div>
                          </v-col>
                          <v-form
                            ref="log"
                            v-model="valid"
                            lazy-validation
                          >
                            <v-col>
                              <v-text-field
                                v-show="!isChangePassword && !isChangeDone"
                                light
                                height="50"
                                id="email"
                                ref="email"
                                v-model="email"
                                :rules="emailRules"
                                single-line
                                label="Email Address"
                                required
                              ></v-text-field>
                              <v-select
                                v-show="!isChangePassword && !isChangeDone"
                                class="mb-4"
                                height="50"
                                :items="companies.map(x => {
                                  return {text: x.companyname, value: x._id};
                                })"
                                v-model="companyid"
                                v-bind:error="errorindex == 0"
                                dense
                                placeholder="Company"
                                persistent-hint
                                single-line hint="Please choose company">
                              </v-select>
                              <p v-show="isChangePassword" class="text-truncate" style="text-align: center">Temporary password was sent to your email</p>
                              <v-text-field
                                v-show="isChangePassword"
                                light
                                height="50"
                                id="temppassword"
                                ref="temppassword"
                                v-model="temppassword"
                                :rules="passRules"
                                single-line
                                label="Temporary Password"
                                hint="Enter your temporary password"
                                required
                              ></v-text-field>
                              <v-text-field
                                v-show="isChangePassword"
                                light
                                height="50"
                                id="newpassword"
                                ref="newpassword"
                                v-model="newpassword"
                                :rules="passRules"
                                single-line
                                type="password"
                                label="New Password"
                                hint="Enter your new password"
                                required
                              ></v-text-field>
                              <v-text-field
                                v-show="isChangePassword"
                                v-bind:error="errorindex == 1"
                                light
                                height="50"
                                id="newpassword2"
                                ref="newpassword2"
                                v-model="newpassword2"
                                :rules="passRules"
                                single-line
                                type="password"
                                label="Confirm New Password"
                                hint="Confirm your new password"
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col class="d-flex justify-space-between">
                              <v-btn
                                v-show="!isChangePassword && !isChangeDone"
                                class="text-capitalize"
                                light
                                large
                                block
                                :disabled="email.length === 0"
                                color="primary"
                                :loading="isFetching"
                                @click="resetpassword">
                                Reset Password
                              </v-btn>
                              <v-btn
                                v-show="isChangePassword"
                                class="text-capitalize"
                                light
                                large
                                block
                                :disabled="newpassword.length < 5"
                                color="primary"
                                :loading="isFetching"
                                @click="changepassword">
                                Change Password
                              </v-btn>
                              <v-btn
                                to="/login"
                                v-show="isChangeDone"
                                class="text-capitalize"
                                light
                                large
                                block
                                color="success">
                                Done
                              </v-btn>
                            </v-col>
                            <v-row>
                            <v-col class="d-flex justify-center" cols="12">  
                              <v-btn
                                to="/login"
                                small
                                text
                                class="text-capitalize primary--text">
                                Login
                              </v-btn>
                            </v-col>
                            </v-row>
                          </v-form>
                        </v-row>
                      </v-container>
                    </v-form>
              </div>
            </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="alert"
      color="blue">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ResetPassword',
  data() {
    return {
      valid: true,
      email: '',
      errorindex: undefined,
      temppassword: '',
      newpassword: '',
      newpassword2: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
        v => v.toLowerCase() === this.email
      ],
      passRules: [
        v => !!v || 'Password is required',
        v => v.length >= 6 || 'Min 6 characters'
      ],
      alert: false,
      message: '',
      companies: [],
      companyid: null,
    }
  },
  methods: {
    ...mapActions('Authentication', ['resetUserPassword', 'changeUserPassword', 'clearResetUserPassword']),
    ...mapActions('Company', ['getCompaniesByTokenRequest']),
    checkError1(){
      if(!this.companyid){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    checkError2(){
      if(this.newpassword!==this.newpassword2){
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    resetpassword(){
      if(this.checkError1() == false) return;
      this.resetUserPassword({email: this.email, companyid: this.companyid});
    },
    changepassword(){
      if(this.checkError2() == false) return;
      const change = {
        useremail: this.email,
        companyid: this.companyid,
        temppassword: this.temppassword,
        newpassword: this.newpassword,
      };
      this.changeUserPassword(change);
    },
  },
  computed: {
    ...mapState('Authentication', {
      isFetching: state => state.isFetching,
      isChangePassword: state => state.isChangePassword,
      isChangeDone: state => state.isChangeDone,
      errorMessage: state => state.errorMessage,
      hasAlert: state => state.hasAlert,
    } ),
  },
  beforeDestroy(){
    this.clearResetUserPassword ();
  },
  watch: {
    errorMessage() {
      this.message = this.errorMessage;
      this.alert = this.hasAlert;
    },
  },
  async created() {
    this.companies = await this.getCompaniesByTokenRequest();
  },
}

</script>

<style src="./ResetPassword.scss" lang="scss"/>
